import { render, staticRenderFns } from "./DeclarationOfConsent.vue?vue&type=template&id=2a2cdfcc&scoped=true&lang=pug&"
import script from "./DeclarationOfConsent.vue?vue&type=script&lang=ts&"
export * from "./DeclarationOfConsent.vue?vue&type=script&lang=ts&"
import style0 from "./DeclarationOfConsent.vue?vue&type=style&index=0&id=2a2cdfcc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2cdfcc",
  null
  
)

export default component.exports